import { Canvas } from "./Components/Canvas";

function App() {
  return (
    <div className="App">
      <Canvas />
    </div>
  );
}

export default App;
